import { render, staticRenderFns } from "./StockQueryLog.vue?vue&type=template&id=021585ae&"
import script from "./StockQueryLog.vue?vue&type=script&lang=js&"
export * from "./StockQueryLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports